import React from 'react';
import { Link } from 'react-style-guide';
import { urlService } from 'core-utilities';
import { entityUrl } from 'core-roblox-utilities';
import PropTypes from 'prop-types';
import {
  Thumbnail2d,
  ThumbnailTypes,
  DefaultThumbnailSize,
  ThumbnailFormat
} from 'roblox-thumbnails';
import GameName from './GameName';
import CardInfo from './CardInfo';
import NativeAd from './NativeAd';

const GameTile = React.forwardRef((props, ref) => {
  const { game, pageType, index, sortName, pageContext, sortPosition, dateTime } = props;
  const { placeId, nativeAdData, universeId } = game;
  const referralData = {
    PageType: pageType,
    PlaceId: placeId,
    Position: index + 1
  };

  if (nativeAdData) {
    referralData.NativeAdData = nativeAdData;
  }
  if (sortName) {
    referralData.SortName = sortName;
  }

  if (pageContext?.pageId) {
    referralData.PageId = pageContext?.pageId;
  }
  if (sortPosition > -1) {
    referralData.SortPosition = sortPosition + 1;
  }
  let gameReferralUrl = urlService.getUrlWithQueries(
    entityUrl.game.getReferralPath(),
    referralData
  );
  // url service encode timestamp, just be sure no impact for event data collection, so manually append here
  const currentDateTime = dateTime || new Date().toISOString();
  gameReferralUrl = `${gameReferralUrl}&LocalTimestamp=${currentDateTime}`;

  const thumbnail = (
    <Thumbnail2d
      type={ThumbnailTypes.gameIcon}
      size={DefaultThumbnailSize}
      targetId={universeId}
      imgClassName='game-card-thumb'
      format={ThumbnailFormat.jpeg}
    />
  );
  return (
    <div className='game-card-container' ref={ref}>
      <Link url={gameReferralUrl} className='game-card-link' id={game.universeId}>
        <div className='game-card-thumb-container'>
          <div className='game-card-thumb'>{thumbnail}</div>
        </div>
        <GameName game={game} />
        {game.isSponsored ? <NativeAd {...props} /> : <CardInfo game={game} />}
      </Link>
    </div>
  );
});

GameTile.defaultProps = {
  sortName: null,
  sortPosition: -1,
  pageContext: { pageId: null },
  dateTime: null
};
GameTile.propTypes = {
  game: PropTypes.shape({
    universeId: PropTypes.number,
    placeId: PropTypes.number,
    name: PropTypes.string,
    playerCount: PropTypes.number,
    isSponsored: PropTypes.bool,
    nativeAdData: PropTypes.string,
    imageUrl: PropTypes.string
  }).isRequired,
  pageType: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  sortName: PropTypes.string,
  pageContext: PropTypes.shape({ pageId: PropTypes.string }),
  sortPosition: PropTypes.number,
  dateTime: PropTypes.string
};

export default GameTile;
